import {computed, ref} from "vue";
import {keepPreviousData, useInfiniteQuery, useQuery} from "@tanstack/vue-query";
import axios from "axios";
import _ from "lodash";
import moment from "moment";

const perPage = ref(30);
const currentPage = ref(1);
const orderBy = ref('created_at');
const orderDirection = ref('desc');

export const changeOrderBy = (value) => {
  if (value === orderBy.value) {
    orderDirection.value = orderDirection.value === 'asc' ? 'desc' : 'asc';
    return;
  }
  orderBy.value = value;
  orderDirection.value = 'desc';
};

const dateRange = ref([
  moment().subtract(1, 'month').format(),
  moment().format(),
]);

export const kitActivityLogCategories = {
  ONSITE: 'Onsite',
  PLATFORM_WIDE: 'Platform Wide',
  LOCAL: 'Local',
};

export const handlePageChange = (page) => {
  currentPage.value = page;
};

export const useKitActivityLogs = () => {
  if (dateRange.value.length === 0) {
    dateRange.value = [
      moment().subtract(1, 'month').format(),
      moment().format(),
    ];
  }

  const query = useQuery({
    queryKey: ['activityLogs', dateRange, currentPage, orderBy, orderDirection],
    queryFn: async () => {
      const queryString = new URLSearchParams({
        page: currentPage.value,
        perPage: perPage.value,
        fromDate: dateRange.value[0],
        toDate: dateRange.value[1],
        orderBy: orderBy.value,
        orderDirection: orderDirection.value,
      });

      const {data} = await axios.get(`/ajax/v2/kit-activity-log?${queryString.toString()}`);

      return data;
    },
  });

  const kitActivityLogs = computed(() => {
    return query?.data?.value?.data ?? [];
  });

  const queryMeta = computed(() => {
    return query?.data?.value?.meta ?? {};
  });

  const handleLoadMore = async () => {
    if (query.hasNextPage.value && !query.isFetchingNextPage.value) {
      await query.fetchNextPage();
    }
  };

  return {
    ...query,
    currentPage,
    queryMeta,
    dateRange,
    orderBy,
    orderDirection,
    kitActivityLogs,
    handleLoadMore,
  };
};
